import React from 'react';
import './main.less';

import { bindActionCreators } from 'redux';
import { reduxForm, Field } from 'redux-form';
import { connect } from 'react-redux';

import get from 'lodash/get';

import { namespace, actions, selectors } from '../';

import SelectField from '../../../shared/form-elements/select/field';
import InputField from '../../../shared/form-elements/input';
import Calendar from '../../../shared/calendar/main';

import { isRequired, isSelected } from '../../../shared/form/validation';

import withIntl from '../../../shared/intl-hoc';

function Form({ intl, calendar, ...props }) {
	return (
		<form
			className='marketing-funnel-activity-form'
			onSubmit={props.handleSubmit}
		>
			<div className='marketing-funnel-activity-form-group'>
				<div className='marketing-funnel-activity-form-field'>
					<Field
						name='name'
						component={InputField}
						validate={[isRequired]}
						placeholder={intl('Name')}
					/>
				</div>
				<div className='marketing-funnel-activity-form-field'>
					<Field
						name='offers'
						placeholder={intl('Offers')}
						component={SelectField}
						searchable={true}
						multi={true}
						options={props.offersLookups}
					/>
				</div>
				<div className='marketing-funnel-activity-form-field'>
					<Field
						name='countries'
						placeholder={intl('Geos')}
						component={SelectField}
						searchable={true}
						multi={true}
						options={props.locationsLookups}
					/>
				</div>
				<div className='marketing-funnel-activity-form-field'>
					<Field
						name='tag'
						placeholder={intl('Tag')}
						component={SelectField}
						searchable={true}
						multi={false}
						options={props.tagsLookups}
					/>
				</div>
				<div className='marketing-funnel-activity-form-field'>
					<Field
						name='type'
						placeholder={intl('Type')}
						component={SelectField}
						validate={[isSelected]}
						searchable={false}
						multi={false}
						options={props.types}
					/>
				</div>
			</div>
			<div className='marketing-funnel-activity-form-group'>
				<div className='marketing-funnel-activity-form-field'>
					<Field
						name='utm_source'
						component={InputField}
						placeholder={intl('UTM source')}
					/>
				</div>
				<div className='marketing-funnel-activity-form-field'>
					<Field
						name='utm_medium'
						component={InputField}
						placeholder={intl('UTM medium')}
					/>
				</div>
				<div className='marketing-funnel-activity-form-field'>
					<Field
						name='utm_campaign'
						component={InputField}
						placeholder={intl('UTM campaign')}
					/>
				</div>
				<div className='marketing-funnel-activity-form-field'>
					<Field
						name='utm_term'
						component={InputField}
						placeholder={intl('UTM term')}
					/>
				</div>
				<div className='marketing-funnel-activity-form-field'>
					<Field
						name='utm_content'
						component={InputField}
						placeholder={intl('UTM content')}
					/>
				</div>
			</div>
			<div className='marketing-funnel-activity-form-group'>
				<div className='marketing-funnel-activity-form-field'>
					<Field
						name='price'
						component={InputField}
						placeholder={intl('Price')}
					/>
				</div>
				<div className='marketing-funnel-activity-form-field'>
					<Field
						name='comment'
						component={InputField}
						placeholder={intl('Comment')}
					/>
				</div>
				<div className='marketing-funnel-activity-form-field calendar'>
					<Calendar
						isMaxDateDisabled
						intl={intl}
						{...calendar}
						onInit={calendar.formCalendarInit}
						onToggle={calendar.formCalendarToggle}
						onChange={calendar.formCalendarChange}
						onApply={calendar.formCalendarApply}
					/>
				</div>

				<button className='ui-btn ui-btn-primary marketing-funnel-activity-form-button'>
					{intl('Save')} {props.id}
				</button>
			</div>
		</form>
	);
}

function mapStateToProps(state) {
	const values = selectors.getInitialValues(state);

	return {
		destroyOnUnmount: selectors.select(state, 'destroyOnUnmount'),

		initialValues: values,
		id: get(values, 'id'),

		calendar: selectors.getFormCalendar(state),
		types: selectors.getActivityTypes(state)
	};
}

function mapDispatchToProps(dispatch) {
	return {
		...bindActionCreators(actions.own, dispatch),
		calendar: bindActionCreators(actions.formCalendar, dispatch)
	};
}

function mergeProps(stateProps, dispatchProps, ownProps) {
	return {
		...ownProps,
		...stateProps,
		...dispatchProps,
		calendar: {
			...stateProps.calendar,
			...dispatchProps.calendar
		}
	};
}

const Main = reduxForm({ form: `${namespace}Form`, enableReinitialize: true })(withIntl(Form));

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(Main);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/marketing-funnel/activity/form/main.js